export enum EndpointsLeads {
  ContractationConfig = "/contractacio/config",
  Scoring = "/leads/solvencia/:lead_id",
  DNIValidation = "/leads/dni-validation/:lead_id",
  Leads = "/leads",
  OfferPdf = "/leads/:lead_id/offer-pdf",
  GasContractationConfig = "/gas/contractacio/config/cups/:cups",
  GasLeads = "/gas/leads",
  GasOfferPdf = "/gas/leads/:lead_id/offer-pdf"
}

export enum EndpointsProducts {
	Pricelist = "/pricelist",
	GasPricelist = "/gas/pricelist"
}